// Price Range Drager Start
      function initPriceSlider() {
        var priceSlider = document.getElementById('price-slider');
        if (!priceSlider || priceSlider.noUiSlider) return;

        function getQueryParam(param) {
          const urlParams = new URLSearchParams(window.location.search);
          return urlParams.get(param);
        }

        const minFromUrl = parseInt(getQueryParam('filter.v.price.gte')) || 0;
        const maxFromUrl = parseInt(getQueryParam('filter.v.price.lte')) || 1000;

        noUiSlider.create(priceSlider, {
          start: [minFromUrl, maxFromUrl],
          connect: true,
          step: 10,
          range: {
            'min': 0,
            'max': 1000
          }
        });

        const priceMinInput = document.getElementById('price-min');
        const priceMaxInput = document.getElementById('price-max');
        const priceMinDisplay = document.getElementById('price-min-display');
        const priceMaxDisplay = document.getElementById('price-max-display');

        priceSlider.noUiSlider.on('update', function (values) {
          const min = Math.round(values[0]);
          const max = Math.round(values[1]);
          priceMinDisplay.value = min;
          priceMaxDisplay.value = max;
          priceMinInput.value = min;
          priceMaxInput.value = max;
        });

        priceMinDisplay.addEventListener('change', function () {
          let min = parseInt(priceMinDisplay.value) || 0;
          let max = parseInt(priceMaxDisplay.value) || 1000;
          priceSlider.noUiSlider.set([min, max]);
        });

        priceMaxDisplay.addEventListener('change', function () {
          let min = parseInt(priceMinDisplay.value) || 0;
          let max = parseInt(priceMaxDisplay.value) || 1000;
          priceSlider.noUiSlider.set([min, max]);
        });

        priceSlider.noUiSlider.on('change', function () {
          priceMinInput.closest('form').submit();
        });
      }

      document.addEventListener('DOMContentLoaded', function () {
        initPriceSlider();
      });

      // 🔄 Use MutationObserver instead of shopify:section:load
      const observer = new MutationObserver(() => {
        initPriceSlider();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

// Price Range Drager End



$( document ).ready(function() {

  setTimeout(function() {
    // var $wizardContent = $('.wizard__content');
    // if ($wizardContent.length) {
    //   $wizardContent.find('p').empty();
    // }
    $('.tmenu-watermark').remove();

    
  }, 1000 ); // 1000ms = 1 second



});